import 'twin.macro';
import React from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import Dialog from '@teetsh/app/src/components/Dialog';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import { LockClosedIcon as LockClosed } from '@heroicons/react/24/outline';
import { BoltIcon as LightningBolt } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { BillingInfos } from 'types/user';

export interface LimitReachedDialogProps {
  isOpen: boolean;
  item:
    | 'event'
    | 'evaluation'
    | 'programmation'
    | 'seance'
    | 'appel'
    | 'operation';
  limit: number;
  requiredPlan: string;
  billingInfos: BillingInfos;
  onCancel: () => void;
}

export function LimitReachedDialog(props: LimitReachedDialogProps) {
  const { isOpen, item, limit, requiredPlan, billingInfos, onCancel } = props;

  const { t } = useTranslation(['common']);
  return (
    <Dialog isOpen={isOpen} onClose={close}>
      <Dialog.Body>
        <div tw="sm:flex sm:items-start p-3">
          <div tw="mx-auto shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-brand-moderate bg-opacity-40 sm:mx-0 sm:h-10 sm:w-10">
            <LockClosed tw="h-6 w-6 text-neutral-quiet" aria-hidden="true" />
          </div>
          <div tw="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <div tw="text-lg leading-6 font-medium text-neutral-intense mb-5">
              {t(
                `common:components.limitReached.description${
                  billingInfos.isOnOldPricing ? 'OnOldPlan' : ''
                }`,
                {
                  limit: limit,
                  itemLabel: t(
                    `common:components.limitReached.labels.${item}`,
                    {
                      count: limit,
                    },
                  ),
                  currentPlanLabel: billingInfos.currentPlanLabel,
                },
              )}
            </div>
            <div tw="text-neutral-quiet">
              {t(
                `common:components.limitReached.upgradeHint${
                  billingInfos.isOnOldPricing ? 'OnOldPlan' : ''
                }`,
                {
                  requiredPlan,
                },
              )}
            </div>
          </div>
        </div>
      </Dialog.Body>
      <Dialog.Footer>
        <Button
          minimal
          large
          onClick={() => {
            close();
            if (onCancel) {
              onCancel();
            }
          }}
        >
          {t('common:buttons.cancel')}
        </Button>
        <ButtonLink to="/pricing" large icon={LightningBolt} intent="primary">
          {t('common:components.limitReached.upgradedToUnlimited')}
        </ButtonLink>
      </Dialog.Footer>
    </Dialog>
  );
}
